import { CrowdtapEnvironment } from './definition';

export const environment: CrowdtapEnvironment = {
  production: false,
  preview: false,
  global: true,
  emergency: true,
  local: false,
  externalLink: false,
  apiUrl: 'https://dev-api.asksuzy.com/dev-member',
  globalUrl: 'https://corridor-qa.asksuzy.io/api/iso/psmanual',
  signalRUrl: 'https://ws-dev.asksuzy.io',
  facebookAppId: 'xxxxxxxxxx',
  grecaptchaToken: '6LcaClsaAAAAAJWoziDMD8F3PhE9XyQFRTzMj1zK',
  grecaptchaV2Token: '6LfkEVsaAAAAAP4uRsbnzOilVnPTAPKaR6PK7P2i',
  languagePlatform: 'crowdtap.v1',
  segmentToken: 'wXBBEueWah5oR77ZW0sDh9xrzxmLNvpv',
  sharedLinkRoot: 'https://preview-qa.suzy.com/preview',
  launchDarkly: '688251541c331409a1054e8c',
  legalId: '1248700B-3E07-48DF-9427-1885E1FE8213',
  verisoulBundleUri: 'https://v.crowdtap.com/sandbox/bundle.js',
  verisoulProjectId: '1523f73f-1af7-4c08-a336-aef7b3b92c8e'
};
